import { THEME } from '@enmon/commons';
import type { FC, PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import type { DataCyProp } from '@/types';
import type { StaticOptions } from '../types/StaticOptions';

export interface KPIProps extends DataCyProp {
  color?: string;
  /**
   * When used in static context, staticOptions must be provided to the component
   *  */
  staticOptions?: StaticOptions;
}

export const StyledKPI = styled.span<Pick<KPIProps, 'color'>>`
  margin: 0;
  ${({ theme }) => theme.typography.configurations.kpi};

  ${({ color }) =>
    css`
      color: ${color};
    `}
`;

export const KPI: FC<PropsWithChildren<KPIProps>> = ({
  children,
  color = THEME.color.semantic.type.primary,
  staticOptions,
  'data-cy': dataCy,
}) => {
  const { theme } = staticOptions ?? {};
  return (
    <StyledKPI color={color} data-cy={dataCy} theme={theme}>
      {children}
    </StyledKPI>
  );
};
